import { makeVar } from '@apollo/client';

export const subscribeConnectionReactiveVar = makeVar<boolean>(false);
